/**
 * @generated SignedSource<<bbd47b452630890cd6f0a3621800b495>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GCP_VertexSearchAgent_Summary_Fragment$data = {
  readonly summaryText: string | null | undefined;
  readonly summaryWithMetadata: {
    readonly citationMetadata: {
      readonly citations: ReadonlyArray<{
        readonly endIndex: number | null | undefined;
        readonly sources: ReadonlyArray<{
          readonly referenceIndex: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly startIndex: number | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly references: ReadonlyArray<{
      readonly document: string | null | undefined;
      readonly title: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly summary: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "GCP_VertexSearchAgent_Summary_Fragment";
};
export type GCP_VertexSearchAgent_Summary_Fragment$key = {
  readonly " $data"?: GCP_VertexSearchAgent_Summary_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"GCP_VertexSearchAgent_Summary_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GCP_VertexSearchAgent_Summary_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summaryText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SummaryWithMetadata",
      "kind": "LinkedField",
      "name": "summaryWithMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CitationMetadata",
          "kind": "LinkedField",
          "name": "citationMetadata",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Citation",
              "kind": "LinkedField",
              "name": "citations",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIndex",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIndex",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CitationSource",
                  "kind": "LinkedField",
                  "name": "sources",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referenceIndex",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SummaryReference",
          "kind": "LinkedField",
          "name": "references",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "document",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Summary",
  "abstractKey": null
};

(node as any).hash = "4dbc05d0b73821b3caf259d84dcc15c2";

export default node;
